export default {  
  modalCompany: false,
  companySent: false,
  company: {},
  companies: [],
};
